import React from "react";
import { Grid, CardMedia, CardContent, Typography, Button } from "@mui/material";
import MuiCard from "@mui/material/Card";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./Wishlist.scss";

const RenderWishlist = ({ items = [], onRemove }) => {
    if (!items.length) {
        return (
            <div className="empty-wishlist">
                <p>Your wishlist is empty 😔</p>
                <Link to="/products" className="btn">
                    Start Shopping
                </Link>
            </div>
        );
    }

    return (
        <Grid container spacing={3} justifyContent="center" className="wishlist-grid">
            {items.map((item) => (
                <Grid item key={item.id} xs={12} sm={6} md={3}>
                    <MuiCard
                        className="wishlist-card"
                        sx={{
                            borderRadius: 0,
                            boxShadow: 'none',
                            transition: "all 0.3s ease",
                            "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={`${process.env.REACT_APP_UPLOAD_URL}${item.img1.url || "/placeholder.png"}`}
                            alt={item.title}
                            sx={{ height: 200, objectFit: "contain" }}
                        />
                        <CardContent>
                            <Typography variant="h5" style={{ fontSize: "14px" }} gutterBottom noWrap>
                                {item.title}
                            </Typography>
                        </CardContent>
                        <Button
                            component={Link}
                            to={`/product/${item.slug || item.documentId}`}
                            variant="outlined"
                            color="primary"
                            sx={{ m: 2 }}
                        >
                            <FormattedMessage id="wishlist_view_product" defaultMessage="Zobacz produkt" />
                        </Button>
                        {onRemove && (
                            <Button
                                variant="text"
                                onClick={() => onRemove(item.documentId)}
                                sx={{ mx: 2, mb: 2, mt: -1 }}
                            >
                                <FormattedMessage id="wishlist_remove" defaultMessage="Usuń z listy" />
                            </Button>
                        )}
                    </MuiCard>
                </Grid>
            ))}
        </Grid>
    );
};

export default RenderWishlist;

















